module.exports = __webpack_public_path__ + "static/media/bg_introduction.f6ff0c0c.png";